import {Service} from "@/apiServices/Service";

export class TratamientoService extends Service {
    constructor() {
        super('tratamientos/');
    }
    obtenerTratamientosPorTipoDenticion(idTipoDenticion){
        return this.http.get(this.getUrl(['obtenerTratamientos','idTipoDenticion', idTipoDenticion]))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTtratamientosPorEspecialidad(idEspecialidad){
        return this.http.get(this.getUrl(['obtenerTratamientos',idEspecialidad]))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTratamientosPorClinica(idClinina){
        return this.http.get(this.getUrl(['obtenerTratamientos','idClinica', idClinina]))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}